import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40faa75f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40faa75f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40faa75f')) {
      api.createRecord('40faa75f', component.options)
    } else {
      api.reload('40faa75f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40faa75f&scoped=true&", function () {
      api.rerender('40faa75f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/systemCreator/systemConfig/storeConfig/index.vue"
export default component.exports